import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, Transition as _Transition } from "vue";
const _hoisted_1 = {
  key: 0,
  "data-cy": "user-edit-panel",
  class: "fixed top-20 right-0 bg-white shadow-2xl z-50 flex flex-col rounded-lg overflow-hidden",
  style: {
    "width": "55vw",
    "min-width": "600px",
    "max-width": "1000px",
    "height": "calc(100vh - 80px)"
  }
};
const _hoisted_2 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-gray-200"
};
const _hoisted_3 = {
  class: "text-xl font-semibold text-gray-900"
};
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-500 mt-0.5"
};
const _hoisted_5 = {
  key: 0,
  class: "border-b border-gray-200"
};
const _hoisted_6 = {
  key: 1,
  class: "flex-1 overflow-auto p-6"
};
const _hoisted_7 = {
  key: 2,
  class: "flex-1 overflow-auto p-6"
};
const _hoisted_8 = {
  key: 0,
  class: "mb-4 p-4 bg-amber-50 rounded-lg border border-amber-200"
};
const _hoisted_9 = {
  class: "space-y-4"
};
const _hoisted_10 = {
  class: "flex items-start"
};
const _hoisted_11 = {
  class: "w-2/3 pr-4"
};
const _hoisted_12 = {
  key: 1,
  class: "text-sm text-gray-900 pt-2",
  "data-cy": "user-email"
};
const _hoisted_13 = {
  class: "flex items-start"
};
const _hoisted_14 = {
  class: "w-2/3 pr-4"
};
const _hoisted_15 = {
  class: "flex items-start"
};
const _hoisted_16 = {
  class: "w-2/3 pr-4"
};
const _hoisted_17 = {
  class: "flex items-start"
};
const _hoisted_18 = {
  class: "w-2/3 pr-4"
};
const _hoisted_19 = {
  key: 0,
  class: "flex items-start"
};
const _hoisted_20 = {
  class: "w-2/3 pr-4"
};
const _hoisted_21 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
};
const _hoisted_22 = {
  key: 1,
  class: "flex items-start"
};
const _hoisted_23 = {
  class: "mt-6 pt-4 border-t border-gray-200"
};
const _hoisted_24 = {
  class: "space-y-1"
};
const _hoisted_25 = {
  class: "flex items-center"
};
const _hoisted_26 = {
  class: "w-2/3"
};
const _hoisted_27 = {
  class: "flex items-center"
};
const _hoisted_28 = {
  class: "w-2/3"
};
const _hoisted_29 = {
  class: "flex items-center"
};
const _hoisted_30 = {
  class: "w-2/3"
};
const _hoisted_31 = {
  class: "flex items-center"
};
const _hoisted_32 = {
  class: "w-2/3"
};
const _hoisted_33 = {
  key: 0,
  class: "mt-6 pt-4 border-t border-gray-200"
};
const _hoisted_34 = {
  class: "flex items-center"
};
const _hoisted_35 = {
  class: "w-2/3 pr-4"
};
const _hoisted_36 = {
  class: "mb-6"
};
const _hoisted_37 = {
  class: "space-y-3"
};
const _hoisted_38 = {
  class: "flex items-center"
};
const _hoisted_39 = {
  class: "w-2/3 pr-4"
};
const _hoisted_40 = {
  class: "w-1/3 pr-4"
};
const _hoisted_41 = {
  key: 1,
  class: "text-sm font-medium text-gray-700 uppercase"
};
const _hoisted_42 = {
  class: "w-2/3 pr-4 flex items-center gap-2"
};
const _hoisted_43 = {
  class: "flex mt-4"
};
const _hoisted_44 = {
  class: "w-2/3 pr-4"
};
const _hoisted_45 = {
  key: 0,
  class: "mb-4"
};
const _hoisted_46 = {
  class: "space-y-3"
};
const _hoisted_47 = {
  key: 0,
  class: "flex items-start"
};
const _hoisted_48 = {
  class: "w-2/3 pr-4"
};
const _hoisted_49 = {
  key: 1,
  class: "flex items-start"
};
const _hoisted_50 = {
  class: "w-2/3 pr-4"
};
const _hoisted_51 = {
  key: 1,
  class: "mb-4 pt-4 border-t border-gray-200"
};
const _hoisted_52 = {
  class: "space-y-3"
};
const _hoisted_53 = {
  class: "flex items-start"
};
const _hoisted_54 = {
  class: "w-2/3 pr-4"
};
const _hoisted_55 = {
  class: "flex items-start"
};
const _hoisted_56 = {
  class: "w-2/3 pr-4"
};
const _hoisted_57 = {
  class: "flex items-start"
};
const _hoisted_58 = {
  class: "w-2/3 pr-4"
};
const _hoisted_59 = {
  key: 2,
  class: "mb-4 pt-4 border-t border-gray-200"
};
const _hoisted_60 = {
  class: "space-y-3"
};
const _hoisted_61 = {
  class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
};
const _hoisted_62 = {
  class: "w-2/3 pr-4"
};
const _hoisted_63 = {
  class: "flex items-center justify-between px-6 py-4 border-t border-gray-200 bg-gray-50",
  style: {
    "margin-right": "56px"
  }
};
const _hoisted_64 = {
  class: "flex items-center gap-2"
};
const _hoisted_65 = {
  class: "flex items-center gap-3"
};
import { ref, computed, reactive, watch } from 'vue';
import { storeToRefs } from 'pinia';
import axios from 'axios';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTabs from '@/components/LlTabs.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import RateChangeConfirmationModal from './RateChangeConfirmationModal.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useCompanyBillingStore } from '@/modules/settings/integrations/QBO/companyBillingStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import ListsService from '@/services/ListsService';
import { isValidSingleEmail } from '@/services/utils';
export default {
  __name: 'UserEditPanel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: null
    },
    initialTab: {
      type: String,
      default: 'details'
    },
    mode: {
      type: String,
      default: 'invite',
      validator: v => ['invite', 'accountant'].includes(v)
    }
  },
  emits: ['update:modelValue', 'close', 'saved', 'tab-change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Stores & services
    const {
      me,
      features
    } = storeToRefs(useMeStore());
    const {
      getMe
    } = useMeStore();
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const accountsStore = useAccountsStore();
    const companyBillingStore = useCompanyBillingStore();
    const {
      handleError,
      handleSuccess,
      handleWarning
    } = useSnackbarHandler();
    const listsService = new ListsService();

    // Refs
    const formRef = ref(null);
    const formValid = ref(true);
    const loading = ref(false);
    const saving = ref(false);
    const activeTab = ref('details');
    const confirmationDialog = ref(null);
    const zeroRateAlert = ref(null);
    const showRateChangeModal = ref(false);
    const saveWithZeroRate = ref(false);
    const confirmExternalUser = ref(false);
    const pendingRatePayload = ref(null);

    // Dialog state
    const dialogOptions = ref({
      title: '',
      message: '',
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    });

    // Loaded data
    const selectedUserData = ref({});
    const accountState = ref({});
    const isUserInvited = ref(false);
    const roleOptions = ref([]);
    const invoiceClassOptions = ref([]);
    const distributionCategoryOptions = ref([]);
    const originalRates = ref(null);
    const originalSnapshot = ref(null);
    const isEditMode = computed(() => !!props.userId);
    const isAccountantMode = computed(() => !isEditMode.value && props.mode === 'accountant');
    const isAccountantRole = computed(() => isAccountantMode.value || selectedUserData.value?.role === 'accountant');
    const availableTabs = computed(() => {
      const tabs = [{
        value: 'details',
        label: 'Details',
        dataCy: 'tab-details'
      }];
      if (isEditMode.value && !isAccountantRole.value) {
        tabs.push({
          value: 'rates',
          label: 'Rates',
          dataCy: 'tab-rates'
        });
      }
      if (isEditMode.value) {
        tabs.push({
          value: 'advanced',
          label: 'Advanced',
          dataCy: 'tab-advanced'
        });
      }
      return tabs;
    });
    const headerName = ref('User');
    const userFullName = computed(() => `${formState.firstName} ${formState.lastName}`.trim() || 'User');

    // Form state
    const formState = reactive({
      email: '',
      firstName: '',
      lastName: '',
      initials: '',
      ledesInitials: '',
      role: '',
      roleDescription: '',
      invoiceClass: null,
      distributionCategory: null,
      ledesCode1998B: '',
      ledesCodeNew: '',
      accessToFirmSetup: false,
      ccResponsibleInvoices: false,
      includeOnAllMatters: false,
      ccMeOnInvoicesByDefault: false
    });
    const ratesForm = reactive({
      standard: 0,
      other: []
    });
    const customFields = reactive([]);
    const takeSnapshot = () => {
      originalSnapshot.value = {
        form: JSON.stringify(formState),
        rates: JSON.stringify(ratesForm),
        customFields: JSON.stringify(customFields)
      };
    };
    const hasChanges = computed(() => {
      if (!isEditMode.value) return true;
      if (!originalSnapshot.value) return false;
      return JSON.stringify(formState) !== originalSnapshot.value.form || JSON.stringify(ratesForm) !== originalSnapshot.value.rates || JSON.stringify(customFields) !== originalSnapshot.value.customFields;
    });
    const canSubmit = computed(() => {
      if (isEditMode.value) return hasChanges.value;
      // Invite / accountant mode: require filled fields
      const hasRequired = !!formState.email?.trim() && !!formState.firstName?.trim() && !!formState.lastName?.trim() && (isAccountantRole.value || !!formState.role);
      if (isAccountantMode.value) return hasRequired && confirmExternalUser.value;
      return hasRequired;
    });

    // Validation rules
    const rules = {
      required: v => !!v || 'This field is required',
      email: v => isValidSingleEmail(v) || 'Enter a valid email address',
      nonNegative: v => v >= 0 || 'Rate cannot be negative'
    };

    // Watch for panel open to load data
    watch(() => props.modelValue, async isOpen => {
      if (isOpen) {
        headerName.value = 'User';
        activeTab.value = props.initialTab || 'details';
        saveWithZeroRate.value = false;
        confirmExternalUser.value = false;
        await loadPanelData();
      }
    });

    // --- Data Loading ---
    const loadPanelData = async () => {
      loading.value = true;
      try {
        const backgroundCalls = [getMe(), companyBillingStore.listAccountingAccounts()];
        if (companySettings.value?.tags?.enabled) {
          backgroundCalls.push(accountsStore.listInvoiceClassTags());
        }
        const [, accountList, tags = []] = await Promise.all(backgroundCalls);

        // Populate options
        roleOptions.value = listsService.getUserRoles('ledes1998').filter(role => role.id !== 'accountant');
        distributionCategoryOptions.value = companyBillingStore.combineQuickBooksAccounts(accountList, ['asset', 'expense', 'liability', 'income']);
        if (tags.length) {
          invoiceClassOptions.value = tags;
        }
        if (isEditMode.value) {
          await loadUserData(props.userId);
          await loadCustomFields(props.userId);
          takeSnapshot();
        } else {
          resetFormState();
        }
      } catch (error) {
        handleError(error);
      } finally {
        loading.value = false;
      }
    };
    const loadUserData = async userId => {
      const [acctState, userData] = await Promise.all([accountsStore.getAccountState(userId), accountsStore.getuserAccountDetailsById(userId)]);
      accountState.value = acctState;
      selectedUserData.value = userData;
      populateFormFromUserData(userData);
    };
    const populateFormFromUserData = userData => {
      const {
        first,
        last,
        email,
        rates,
        access,
        settings,
        ledesInitials,
        initials,
        invitation
      } = userData || {};
      headerName.value = `${first || ''} ${last || ''}`.trim() || 'User';
      formState.email = email || '';
      formState.firstName = first || '';
      formState.lastName = last || '';
      formState.initials = initials || '';
      formState.ledesInitials = ledesInitials || '';
      formState.accessToFirmSetup = access?.setup || false;
      formState.includeOnAllMatters = access?.include || false;
      formState.ccResponsibleInvoices = settings?.ccPrimary || false;
      formState.ccMeOnInvoicesByDefault = settings?.ccMeOnInvoicesByDefault || false;
      formState.ledesCode1998B = settings?.timeKeeperClassificationLedes || '';
      formState.ledesCodeNew = settings?.timeKeeperClassificationLedesXml || '';

      // Role - find matching label from role id
      const role = roleOptions.value.find(r => r.id === userData.role);
      formState.role = role?.id || userData.role || '';
      formState.roleDescription = role?.description || '';

      // Invoice class
      formState.invoiceClass = settings?.tag?.id || null;

      // Distribution category
      formState.distributionCategory = settings?.distribution?.account?.id || null;

      // Rates
      ratesForm.standard = rates?.standard || 0;
      ratesForm.other = (rates?.other || []).map(r => ({
        ...r
      }));
      originalRates.value = {
        standard: rates?.standard || 0,
        other: (rates?.other || []).map(r => ({
          ...r
        }))
      };
      isUserInvited.value = !!invitation;
    };
    const loadCustomFields = async userId => {
      try {
        const {
          data
        } = await axios.get(`/accounts/${userId}/customFields`);
        customFields.splice(0, customFields.length, ...(data.customFields || []).map(cf => ({
          id: cf.customField.id,
          label: cf.customField.name,
          type: mapFieldType(cf.customField.type),
          textValue: cf.textValue || '',
          numberValue: cf.numberValue,
          enumValueId: cf.enumValue?.id || null,
          enumOptions: (cf.customField.enumOptions || []).map(opt => ({
            id: opt.id,
            value: opt.label
          }))
        })));
      } catch (error) {
        handleError(error);
      }
    };
    const mapFieldType = type => {
      if (typeof type === 'string') return type.toLowerCase();
      // Backend enum: 0=Text, 1=Number, 2=Date, 3=Boolean, 4=Enum/Dropdown
      const typeMap = {
        0: 'text',
        1: 'number',
        2: 'date',
        3: 'boolean',
        4: 'enum'
      };
      return typeMap[type] || 'text';
    };
    const resetFormState = () => {
      Object.assign(formState, {
        email: '',
        firstName: '',
        lastName: '',
        initials: '',
        ledesInitials: '',
        role: '',
        roleDescription: '',
        invoiceClass: null,
        distributionCategory: null,
        ledesCode1998B: '',
        ledesCodeNew: '',
        accessToFirmSetup: false,
        ccResponsibleInvoices: false,
        includeOnAllMatters: false,
        ccMeOnInvoicesByDefault: false
      });
      ratesForm.standard = 0;
      ratesForm.other = [];
      originalRates.value = null;
      customFields.splice(0, customFields.length);
      selectedUserData.value = {};
      accountState.value = {};
      isUserInvited.value = false;
      saveWithZeroRate.value = false;
    };

    // --- Role change handler ---
    const handleRoleChange = value => {
      if (value) {
        const role = roleOptions.value.find(r => r.id === value);
        formState.roleDescription = role?.description || '';
        if (me.value.id !== props.userId) {
          if (['Principal', 'Operator'].includes(role?.label) && !isEditMode.value) {
            formState.accessToFirmSetup = true;
          }
        }
      } else {
        formState.roleDescription = '';
      }
    };

    // --- Rate management ---
    const addRate = () => {
      if (!ratesForm.other) ratesForm.other = [];
      ratesForm.other.push({
        label: '',
        amount: '',
        isNew: true
      });
    };
    const removeRate = index => {
      ratesForm.other.splice(index, 1);
    };
    const confirmRateLabel = rate => {
      if (rate.label) rate.isNew = false;
    };
    const haveRatesChanged = () => {
      if (!originalRates.value) return false;
      if (parseFloat(ratesForm.standard) !== parseFloat(originalRates.value.standard)) return true;
      if ((ratesForm.other?.length || 0) !== (originalRates.value.other?.length || 0)) return true;
      for (let i = 0; i < (ratesForm.other?.length || 0); i++) {
        if (ratesForm.other[i].label !== originalRates.value.other[i]?.label || parseFloat(ratesForm.other[i].amount) !== parseFloat(originalRates.value.other[i]?.amount)) return true;
      }
      return false;
    };

    // --- Save ---
    const handleSave = async () => {
      if (formRef.value) {
        const {
          valid
        } = await formRef.value.validate();
        if (!valid) return;
      }
      if (!saveWithZeroRate.value && !isAccountantRole.value) {
        const ratesChanged = !isEditMode.value || haveRatesChanged();
        if (ratesChanged) {
          const hasZeroRate = parseFloat(ratesForm.standard) === 0 || (ratesForm.other || []).some(r => parseFloat(r.amount) === 0);
          if (hasZeroRate) {
            const confirmed = await zeroRateAlert.value.open();
            if (confirmed) {
              saveWithZeroRate.value = true;
              return handleSave();
            }
            return;
          }
        }
      }

      // Validate required fields
      if (!formState.firstName?.trim() || !formState.lastName?.trim()) {
        handleError('First Name and Last Name are required.');
        return;
      }
      if (!isEditMode.value && !formState.email?.trim()) {
        handleError('Email is required.');
        return;
      }
      if (isAccountantMode.value && !confirmExternalUser.value) {
        handleWarning('Please confirm that the user is external to the firm in the checkbox above');
        return;
      }

      // Check if rates changed in edit mode
      if (isEditMode.value && haveRatesChanged()) {
        pendingRatePayload.value = null;
        showRateChangeModal.value = true;
        return;
      }
      await executeSave();
    };
    const handleRateChangeConfirmed = async rateOptions => {
      showRateChangeModal.value = false;
      pendingRatePayload.value = rateOptions;
      await executeSave();
    };
    const executeSave = async () => {
      saving.value = true;
      try {
        const roleObj = roleOptions.value.find(r => r.id === formState.role);
        const distributionAccount = distributionCategoryOptions.value.find(c => c.id === formState.distributionCategory);
        const invoiceClassTag = invoiceClassOptions.value.find(t => t.id === formState.invoiceClass);
        const payload = {
          access: {
            setup: formState.accessToFirmSetup,
            include: formState.includeOnAllMatters
          },
          email: formState.email,
          first: formState.firstName,
          last: formState.lastName,
          initials: formState.initials,
          ledesInitials: formState.ledesInitials,
          settings: {
            distribution: {
              account: distributionAccount ? {
                id: distributionAccount.id,
                name: distributionAccount.name,
                type: distributionAccount.type,
                subtype: distributionAccount.subtype,
                balance: distributionAccount.balance,
                label: distributionAccount.label
              } : {
                id: null
              }
            },
            timeKeeperClassificationLedes: formState.ledesCode1998B,
            timeKeeperClassificationLedesXml: formState.ledesCodeNew,
            tag: invoiceClassTag ? {
              id: invoiceClassTag.id,
              label: invoiceClassTag.label
            } : null,
            ccMeOnInvoicesByDefault: formState.ccMeOnInvoicesByDefault,
            ccPrimary: formState.ccResponsibleInvoices
          },
          rates: {
            standard: parseFloat(ratesForm.standard),
            other: (ratesForm.other || []).map(r => ({
              label: r.label,
              amount: parseFloat(r.amount)
            }))
          },
          role: isAccountantRole.value ? 'accountant' : formState.role || roleObj?.id
        };

        // Include rate change options if applicable
        if (pendingRatePayload.value) {
          payload.rateOptions = pendingRatePayload.value;
        }
        if (isEditMode.value) {
          await accountsStore.updateAccount(props.userId, payload);
          await saveCustomFields();
        } else {
          await accountsStore.createAccountAndSendInvitation(payload);
        }
        emit('saved');
      } catch (error) {
        handleError(error);
      } finally {
        saving.value = false;
        pendingRatePayload.value = null;
      }
    };

    // --- Custom Fields Save ---
    const saveCustomFields = async () => {
      if (!customFields.length) return;
      try {
        const payload = {
          customFields: customFields.map(cf => ({
            id: cf.id,
            textValue: cf.type === 'text' ? cf.textValue : undefined,
            numberValue: cf.type === 'number' ? cf.numberValue : undefined,
            enumValueId: cf.type === 'enum' ? cf.enumValueId : undefined
          }))
        };
        await axios.put(`/accounts/${props.userId}/customFields`, payload);
      } catch (error) {
        handleError(error);
      }
    };

    // --- User Management Actions ---
    const openConfirmation = options => {
      dialogOptions.value = {
        title: options.title || '',
        message: options.message || '',
        confirmText: options.confirmText || 'OK',
        cancelText: options.cancelText || 'Cancel'
      };
      return confirmationDialog.value.open();
    };
    const loadSubscriptionCost = async isDisabled => {
      const costParams = isDisabled ? {
        addSeat: 1
      } : {
        removeSeat: 1
      };
      return accountsStore.getSubscriptionCost(costParams);
    };
    const enableUser = async () => {
      const cost = await loadSubscriptionCost(true);
      const confirmed = await openConfirmation({
        title: 'Enable this user?',
        message: `${cost?.message || ''}. ${cost?.detail || ''}`.trim()
      });
      if (confirmed) {
        saving.value = true;
        await accountsStore.archiveAccount(selectedUserData.value.id, {
          archive: false
        });
        saving.value = false;
        emit('saved');
      }
    };
    const disableOrRemoveUser = async () => {
      if (formState.role !== 'accountant') {
        await loadSubscriptionCost(false);
      }
      if (accountState.value?.activity) {
        await disableUser();
      } else {
        await removeUser();
      }
    };
    const disableUser = async () => {
      const cost = await loadSubscriptionCost(false);
      const message = `The user's activity (time entries, expenses, or similar) will remain in the system. The user will not be able to log in, and new time entries cannot be created for them, but they will still appear in certain reports.${formState.role !== 'accountant' ? ` ${cost?.message || ''} ${cost?.detail || ''}` : ''}`.trim();
      const confirmed = await openConfirmation({
        title: 'Disable this user?',
        message
      });
      if (confirmed) {
        saving.value = true;
        await accountsStore.archiveAccount(selectedUserData.value.id, {
          archive: true
        });
        saving.value = false;
        emit('saved');
      }
    };
    const removeUser = async () => {
      const cost = await loadSubscriptionCost(false);
      const confirmed = await openConfirmation({
        title: 'Remove this user from your account?',
        message: `This cannot be undone (but we checked that the user doesn't have any activity in the system). ${cost?.message || ''}. ${cost?.detail || ''}`.trim()
      });
      if (confirmed) {
        saving.value = true;
        await accountsStore.deleteAccount(selectedUserData.value.id, {
          archive: true
        });
        saving.value = false;
        emit('saved');
      }
    };
    const reinviteUser = async () => {
      const confirmed = await openConfirmation({
        title: 'Reset Password',
        message: `This will reset the user's password and send an invitation email to them. They won't lose their data. Ok to reset their login?`
      });
      if (confirmed) {
        saving.value = true;
        await accountsStore.inviteAccount(selectedUserData.value.id, selectedUserData.value.email);
        saving.value = false;
        emit('saved');
      }
    };
    const sendInvite = async () => {
      const apiDomain = window.leanlaw?.domain || '';
      const link = `${apiDomain}/account/invite/${selectedUserData.value?.invitation?.id}`;
      const confirmed = await openConfirmation({
        title: '',
        message: `The invite link for this user is\n${link}\nSend it to them again? You can also send this link to them by copying it from above.`
      });
      if (confirmed) {
        saving.value = true;
        await accountsStore.inviteAccount(selectedUserData.value.id, selectedUserData.value.email);
        saving.value = false;
        emit('saved');
      }
    };
    const handleClose = async () => {
      if (hasChanges.value) {
        const confirmed = await openConfirmation({
          title: 'Unsaved Changes',
          message: 'You have unsaved changes. Are you sure you want to close? Your changes will be lost.',
          confirmText: 'Discard Changes',
          cancelText: 'Keep Editing'
        });
        if (!confirmed) return;
      }
      emit('update:modelValue', false);
      emit('close');
    };
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_Transition, {
        name: "slide-panel",
        "enter-active-class": "slide-panel-enter-active",
        "leave-active-class": "slide-panel-leave-active",
        "enter-from-class": "slide-panel-enter-from",
        "enter-to-class": "slide-panel-enter-to",
        "leave-from-class": "slide-panel-leave-from",
        "leave-to-class": "slide-panel-leave-to"
      }, {
        default: _withCtx(() => [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("h2", _hoisted_3, _toDisplayString(isEditMode.value ? 'Edit User' : isAccountantMode.value ? 'Add Accounting Partner' : 'Invite User'), 1), isEditMode.value ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(headerName.value), 1)) : _createCommentVNode("", true)]), _createVNode(LlSecondaryButton, {
          icon: "mdi-close",
          variant: "text",
          size: "small",
          "aria-label": "Close",
          "data-cy": "close-panel-btn",
          onClick: handleClose
        })]), availableTabs.value.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(LlTabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => activeTab.value = $event), _cache[1] || (_cache[1] = $event => emit('tab-change', $event))],
          items: availableTabs.value,
          class: "px-6"
        }, null, 8, ["modelValue", "items"])])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_v_skeleton_loader, {
          type: "article, article"
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives(_createElementVNode("div", null, [isAccountantMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[22] || (_cache[22] = _createElementVNode("p", {
          class: "text-sm text-amber-800 mb-3"
        }, " Accountants or bookkeepers that are not part of your firm can be added to LeanLaw for free. Inviting them does not impact your subscription. This role has access to all functions and information in the system, but not able to have time or expenses tracked against them. ", -1)), _createVNode(LlCheckbox, {
          modelValue: confirmExternalUser.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => confirmExternalUser.value = $event),
          label: "I confirm that this user is not part of our firm",
          "data-cy": "confirm-external-user-checkbox"
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createVNode(_component_v_form, {
          ref_key: "formRef",
          ref: formRef,
          modelValue: formValid.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formValid.value = $event)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, "Email", -1)), _createElementVNode("div", _hoisted_11, [!isEditMode.value ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            modelValue: formState.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formState.email = $event),
            placeholder: "User's email address",
            type: "email",
            rules: [rules.required, rules.email],
            "data-cy": "user-email-input"
          }, null, 8, ["modelValue", "rules"])) : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(formState.email), 1))])]), _createElementVNode("div", _hoisted_13, [_cache[24] || (_cache[24] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, "First Name", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(LlTextField, {
            modelValue: formState.firstName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formState.firstName = $event),
            placeholder: "First name",
            rules: [rules.required],
            "data-cy": "first-name-input"
          }, null, 8, ["modelValue", "rules"])])]), _createElementVNode("div", _hoisted_15, [_cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, "Last Name", -1)), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
            modelValue: formState.lastName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formState.lastName = $event),
            placeholder: "Last name",
            rules: [rules.required],
            "data-cy": "last-name-input"
          }, null, 8, ["modelValue", "rules"])])]), _createElementVNode("div", _hoisted_17, [_cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, [_createTextVNode(" Name/Initials for Invoicing "), _createElementVNode("p", {
            class: "text-xs text-gray-400 font-normal mt-0.5"
          }, "Used on invoices instead of full name")], -1)), _createElementVNode("div", _hoisted_18, [_createVNode(LlTextField, {
            modelValue: formState.initials,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formState.initials = $event),
            placeholder: userFullName.value || 'Initials',
            "data-cy": "initials-input"
          }, null, 8, ["modelValue", "placeholder"])])]), !isAccountantRole.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[27] || (_cache[27] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, "Role", -1)), _createElementVNode("div", _hoisted_20, [_createVNode(LlSelect, {
            modelValue: formState.role,
            "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => formState.role = $event), handleRoleChange],
            items: roleOptions.value,
            placeholder: "Select a role",
            "item-title": "label",
            "item-value": "id",
            "return-object": false,
            rules: [rules.required],
            "data-cy": "role-select"
          }, null, 8, ["modelValue", "items", "rules"]), formState.roleDescription ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(formState.roleDescription), 1)) : _createCommentVNode("", true)])])) : isEditMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[28] || (_cache[28] = [_createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
          }, "Role", -1), _createElementVNode("div", {
            class: "w-2/3 pr-4"
          }, [_createElementVNode("div", {
            class: "text-sm text-gray-900 pt-2"
          }, "Accountant")], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_cache[33] || (_cache[33] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-gray-900 mb-3"
          }, "Access & Permissions", -1)), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[29] || (_cache[29] = _createElementVNode("span", {
            class: "w-1/3 text-sm text-gray-700"
          }, "Firm Setup Access", -1)), _createElementVNode("div", _hoisted_26, [_createVNode(LlCheckbox, {
            modelValue: formState.accessToFirmSetup,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formState.accessToFirmSetup = $event),
            "hide-details": "",
            disabled: isEditMode.value && _unref(me).id === props.userId,
            "data-cy": "access-firm-setup-checkbox"
          }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_27, [_cache[30] || (_cache[30] = _createElementVNode("span", {
            class: "w-1/3 text-sm text-gray-700"
          }, "Include on all matters", -1)), _createElementVNode("div", _hoisted_28, [_createVNode(LlCheckbox, {
            modelValue: formState.includeOnAllMatters,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formState.includeOnAllMatters = $event),
            "hide-details": "",
            "data-cy": "include-all-matters-checkbox"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_29, [_cache[31] || (_cache[31] = _createElementVNode("span", {
            class: "w-1/3 text-sm text-gray-700"
          }, "CC on responsible invoices", -1)), _createElementVNode("div", _hoisted_30, [_createVNode(LlCheckbox, {
            modelValue: formState.ccResponsibleInvoices,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formState.ccResponsibleInvoices = $event),
            "hide-details": "",
            "data-cy": "cc-responsible-invoices-checkbox"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_31, [_cache[32] || (_cache[32] = _createElementVNode("span", {
            class: "w-1/3 text-sm text-gray-700"
          }, "CC by default on sent invoices", -1)), _createElementVNode("div", _hoisted_32, [_createVNode(LlCheckbox, {
            modelValue: formState.ccMeOnInvoicesByDefault,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formState.ccMeOnInvoicesByDefault = $event),
            "hide-details": "",
            "data-cy": "cc-invoices-default-checkbox"
          }, null, 8, ["modelValue"])])])])]), !isEditMode.value && !isAccountantMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_cache[35] || (_cache[35] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-gray-900 mb-3"
          }, "Rate", -1)), _createElementVNode("div", _hoisted_34, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "w-1/3 text-sm font-medium text-gray-700 uppercase"
          }, "Standard", -1)), _createElementVNode("div", _hoisted_35, [_createVNode(LlTextField, {
            modelValue: ratesForm.standard,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ratesForm.standard = $event),
            prefix: "$",
            type: "number",
            placeholder: "0.00",
            rules: [rules.required, rules.nonNegative],
            "data-cy": "standard-rate-input"
          }, null, 8, ["modelValue", "rules"])])])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])], 512), [[_vShow, activeTab.value === 'details']]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_36, [_cache[39] || (_cache[39] = _createElementVNode("h3", {
          class: "text-base font-semibold text-gray-900 mb-4"
        }, "User Rates", -1)), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[36] || (_cache[36] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 uppercase"
        }, "Standard", -1)), _createElementVNode("div", _hoisted_39, [_createVNode(LlTextField, {
          modelValue: ratesForm.standard,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ratesForm.standard = $event),
          prefix: "$",
          type: "number",
          placeholder: "0.00",
          rules: [rules.required, rules.nonNegative],
          "data-cy": "standard-rate-input"
        }, null, 8, ["modelValue", "rules"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratesForm.other, (rate, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex items-center"
          }, [_createElementVNode("div", _hoisted_40, [rate.isNew ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            modelValue: rate.label,
            "onUpdate:modelValue": $event => rate.label = $event,
            placeholder: "Rate name",
            "hide-details": "",
            class: "text-sm",
            onBlur: $event => confirmRateLabel(rate),
            onKeyup: _withKeys($event => confirmRateLabel(rate), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onKeyup"])) : (_openBlock(), _createElementBlock("label", _hoisted_41, _toDisplayString(rate.label), 1))]), _createElementVNode("div", _hoisted_42, [_createVNode(LlTextField, {
            modelValue: rate.amount,
            "onUpdate:modelValue": $event => rate.amount = $event,
            prefix: "$",
            type: "number",
            placeholder: "0.00",
            "hide-details": "",
            class: "flex-1"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(LlSecondaryButton, {
            icon: "mdi-delete",
            color: "error",
            variant: "text",
            size: "small",
            "aria-label": "Remove rate",
            "data-cy": `remove-rate-${index}`,
            onClick: $event => removeRate(index)
          }, null, 8, ["data-cy", "onClick"])])]);
        }), 128))]), _createElementVNode("div", _hoisted_43, [_cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "w-1/3"
        }, null, -1)), _createElementVNode("div", _hoisted_44, [_createVNode(LlSecondaryButton, {
          size: "small",
          "prepend-icon": "mdi-plus",
          onClick: addRate,
          "data-cy": "add-rate-btn"
        }, {
          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode(" Add new rate ", -1)]))]),
          _: 1
        })])])])], 512), [[_vShow, activeTab.value === 'rates']]), _withDirectives(_createElementVNode("div", null, [_unref(me).company.settings.distribution?.account?.id || _unref(me).company.settings.tags?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_cache[42] || (_cache[42] = _createElementVNode("h3", {
          class: "text-base font-semibold text-gray-900 mb-3"
        }, "Invoice & Distribution", -1)), _createElementVNode("div", _hoisted_46, [_unref(me).company.settings.tags?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_cache[40] || (_cache[40] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
        }, "QuickBooks Class", -1)), _createElementVNode("div", _hoisted_48, [_createVNode(LlSelect, {
          modelValue: formState.invoiceClass,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formState.invoiceClass = $event),
          items: invoiceClassOptions.value,
          placeholder: "Select an invoice class",
          "item-title": "label",
          "item-value": "id",
          "return-object": false,
          clearable: "",
          "data-cy": "invoice-class-select"
        }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true), _unref(me).company.settings.distribution?.account?.id ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_cache[41] || (_cache[41] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
        }, [_createTextVNode("Distribution Category "), _createElementVNode("p", {
          class: "text-xs text-gray-400 font-normal mt-0.5"
        }, "Overrides the default category")], -1)), _createElementVNode("div", _hoisted_50, [_createVNode(LlSelect, {
          modelValue: formState.distributionCategory,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formState.distributionCategory = $event),
          items: distributionCategoryOptions.value,
          placeholder: "Default Distribution",
          "item-title": "label",
          "item-value": "id",
          "return-object": false,
          clearable: "",
          "data-cy": "distribution-category-select"
        }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _unref(me).company.settings.codes?.ledes && !isAccountantRole.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_cache[46] || (_cache[46] = _createElementVNode("h3", {
          class: "text-base font-semibold text-gray-900 mb-3"
        }, "LEDES", -1)), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_cache[43] || (_cache[43] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
        }, [_createTextVNode(" LEDES Initials "), _createElementVNode("p", {
          class: "text-xs text-gray-400 font-normal mt-0.5"
        }, "Overrides the TIMEKEEPER_ID field")], -1)), _createElementVNode("div", _hoisted_54, [_createVNode(LlTextField, {
          modelValue: formState.ledesInitials,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formState.ledesInitials = $event),
          placeholder: "e.g. JD",
          "data-cy": "ledes-initials-input"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_55, [_cache[44] || (_cache[44] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
        }, "Timekeeper Classification Codes - 1998B", -1)), _createElementVNode("div", _hoisted_56, [_createVNode(LlTextField, {
          modelValue: formState.ledesCode1998B,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formState.ledesCode1998B = $event),
          "data-cy": "ledes-code-1998b-input"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_57, [_cache[45] || (_cache[45] = _createElementVNode("label", {
          class: "w-1/3 text-sm font-medium text-gray-700 pt-2 pr-4"
        }, "Timekeeper Classification Codes - New", -1)), _createElementVNode("div", _hoisted_58, [_createVNode(LlTextField, {
          modelValue: formState.ledesCodeNew,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formState.ledesCodeNew = $event),
          "data-cy": "ledes-code-new-input"
        }, null, 8, ["modelValue"])])])])])) : _createCommentVNode("", true), customFields.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_cache[48] || (_cache[48] = _createElementVNode("h3", {
          class: "text-base font-semibold text-gray-900 mb-3"
        }, "Custom Fields", -1)), _createElementVNode("div", _hoisted_60, [_cache[47] || (_cache[47] = _createElementVNode("p", null, "Bulk editing custom field values is available on the users page on the 'Custom Fields' tab.", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFields, field => {
          return _openBlock(), _createElementBlock("div", {
            key: field.id,
            class: "flex items-start"
          }, [_createElementVNode("label", _hoisted_61, _toDisplayString(field.label), 1), _createElementVNode("div", _hoisted_62, [field.type === 'text' ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            modelValue: field.textValue,
            "onUpdate:modelValue": $event => field.textValue = $event,
            placeholder: `Enter ${field.label}`,
            "hide-details": "",
            "data-cy": `custom-field-text-${field.id}`
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "data-cy"])) : _createCommentVNode("", true), field.type === 'number' ? (_openBlock(), _createBlock(LlTextField, {
            key: 1,
            modelValue: field.numberValue,
            "onUpdate:modelValue": $event => field.numberValue = $event,
            type: "number",
            placeholder: `Enter ${field.label}`,
            "hide-details": "",
            "data-cy": `custom-field-number-${field.id}`
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "data-cy"])) : _createCommentVNode("", true), field.type === 'enum' ? (_openBlock(), _createBlock(LlSelect, {
            key: 2,
            modelValue: field.enumValueId,
            "onUpdate:modelValue": $event => field.enumValueId = $event,
            items: field.enumOptions,
            "item-title": "value",
            "item-value": "id",
            placeholder: `Select ${field.label}`,
            clearable: "",
            "hide-details": "",
            "data-cy": `custom-field-enum-${field.id}`
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "placeholder", "data-cy"])) : _createCommentVNode("", true)])]);
        }), 128))])])) : _createCommentVNode("", true)], 512), [[_vShow, activeTab.value === 'advanced']])])), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [isEditMode.value && selectedUserData.value.id !== _unref(me).id && !loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [isUserInvited.value && !selectedUserData.value.disabled ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 0,
          size: "small",
          onClick: sendInvite,
          disabled: saving.value,
          "data-cy": "resend-invite-btn"
        }, {
          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" Resend Invite ", -1)]))]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), _unref(features).reset ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 1,
          size: "small",
          onClick: reinviteUser,
          disabled: saving.value,
          "data-cy": "reinvite-btn"
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode(" Reinvite ", -1)]))]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), selectedUserData.value.disabled ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 2,
          size: "small",
          onClick: enableUser,
          disabled: saving.value,
          "data-cy": "enable-user-btn"
        }, {
          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode(" Enable ", -1)]))]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), !selectedUserData.value.disabled ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 3,
          color: "error",
          variant: "flat",
          size: "small",
          onClick: disableOrRemoveUser,
          disabled: saving.value,
          "data-cy": "disable-user-btn"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(accountState.value.activity ? 'Disable' : 'Remove'), 1)]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_65, [_createVNode(LlSecondaryButton, {
          onClick: handleClose,
          "data-cy": "cancel-btn"
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode(" Cancel ", -1)]))]),
          _: 1
        }), _createVNode(LlSecondaryButton, {
          color: "primary",
          loading: saving.value,
          disabled: saving.value || !canSubmit.value,
          onClick: handleSave,
          "data-cy": "save-btn"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(isEditMode.value ? 'Save Changes' : 'Send Invite'), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])]), _createVNode(LlConfirmationDialog, {
          ref_key: "confirmationDialog",
          ref: confirmationDialog,
          title: dialogOptions.value.title,
          message: dialogOptions.value.message,
          "confirm-text": dialogOptions.value.confirmText,
          "toggle-text": dialogOptions.value.cancelText,
          showWarningIcon: true
        }, null, 8, ["title", "message", "confirm-text", "toggle-text"]), _createVNode(LlConfirmationDialog, {
          ref_key: "zeroRateAlert",
          ref: zeroRateAlert,
          showWarningIcon: true,
          title: "",
          "confirm-text": "Save Anyway",
          "toggle-text": "Cancel",
          message: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`
        }, null, 512), _createVNode(_component_v_dialog, {
          modelValue: showRateChangeModal.value,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => showRateChangeModal.value = $event),
          width: "400"
        }, {
          default: _withCtx(() => [_createVNode(RateChangeConfirmationModal, {
            onSave: handleRateChangeConfirmed,
            onCancel: _cache[20] || (_cache[20] = $event => showRateChangeModal.value = false)
          })]),
          _: 1
        }, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};